import React from "react";
import styles from "../styles/ModeSelector.module.css";

export type QuizMode = "time" | "questions" | "endless";

interface ModeSelectorProps {
    value: QuizMode;
    onChange: (mode: QuizMode) => void;
}

const modes: { value: QuizMode; label: string }[] = [
    { value: "time", label: "Time limit" },
    { value: "questions", label: "Question limit" },
    { value: "endless", label: "Endless" },
];

export default function ModeSelector({ value, onChange }: ModeSelectorProps) {
    return (
        <div className={styles.modeSelectorWrapper}>
            <div className={styles.modeLabel}>Mode:</div>
            <div className={styles.modeButtonGroup}>
                {modes.map((mode) => (
                    <button
                        key={mode.value}
                        onClick={() => onChange(mode.value)}
                        className={
                            value === mode.value
                                ? `${styles.modeButton} ${styles.modeButtonActive}`
                                : styles.modeButton
                        }
                    >
                        {mode.label}
                    </button>
                ))}
            </div>
        </div>
    );
}
